import gettext from '@sdk/lang/gettext';

import fieldsVisibilityButtonsHtml from './fieldsVisibilityButtonsComponent.html';

class FieldsVisibilityButtonsCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    ShiftTasksService,
    SlingAnalytics,
    TaskTemplatesService,
    ShiftsEducation,
    $scope,
    $timeout
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      ShiftTasksService,
      SlingAnalytics,
      TaskTemplatesService,
      ShiftsEducation,
      $scope,
      $timeout,
    });
  }

  $onInit() {
    this.initTooltipMessages();
    this.fieldsVisibilityOptions =
      this.Authentication.user.settings.clientFlags.shiftFieldsVisibilityOptions ||
      this.getDefaultVisibilityOptions();
    this.fieldsVisibilityDisabled = this.initFieldsVisibilityDisabled();
    this.ShiftsEducation.trackShiftEditModalOpen(this.shift);
  }

  getDefaultVisibilityOptions() {
    return {
      tagsVisible:
        this.PersonaCollection.tags?.length && this.Authentication.isOrgFeatureEnabled('tags'),
      shiftTasksVisible:
        this.TaskTemplatesService.allTemplates?.length &&
        this.Authentication.isOrgFeatureEnabled('shiftTasks'),
    };
  }

  initFieldsVisibilityDisabled() {
    const { id, rrule, tags, summary, taskInstances, taskTemplates } = this.shift;
    const isPublished = this.shift.status === 'published';

    const relevantShiftTasks = isPublished ? taskInstances : taskTemplates;
    const shiftTasksLocked = id && relevantShiftTasks?.length;

    return {
      recurrenceLocked: Boolean(id && rrule?.interval),
      tagsLocked: Boolean(id && tags?.length),
      notesLocked: Boolean(id && summary),
      shiftTasksLocked,
    };
  }

  initTooltipMessages() {
    this.recurrenceTooltipText = gettext(
      'Add recurrence to this shift to make it repeat over time'
    );
    this.tagsTooltipText = gettext('Add tags to this shift to enable better classification');
    this.shiftTasksTooltipText = gettext('Add tasks to this shift to specify what must be done');
    this.notesTooltipText = gettext('Add notes to this shift to share more information');
  }

  trackShiftTaskInterest() {
    this.SlingAnalytics.track(this.SlingAnalytics.shiftTaskRowClickedByNonBusiness);
  }

  visibilityButtonClicked(type) {
    this.tooltipsHidden = true;
    this.fieldsVisibilityOptions[`${type}Visible`] =
      !this.fieldsVisibilityOptions[`${type}Visible`];

    this.$timeout(() => {
      this.tooltipsHidden = false;
    }, 500);

    this.Authentication.user.settings.clientFlags.shiftFieldsVisibilityOptions =
      this.fieldsVisibilityOptions;
    this.Authentication.syncSettings();
  }
}

export default {
  controllerAs: 'ctrl',
  controller: FieldsVisibilityButtonsCtrl,
  bindings: {
    shift: '=',
    fieldsVisibilityOptions: '=',
    fieldsVisibilityDisabled: '=',
    shouldShowRecurrenceButton: '<',
  },
  templateUrl: fieldsVisibilityButtonsHtml,
};
